export const POST_MODERATION_PATH = "/posts-moderation/:postId";
